export var TextureCompareMode;
(function (TextureCompareMode) {
    TextureCompareMode[TextureCompareMode["None"] = 0] = "None";
    TextureCompareMode[TextureCompareMode["LEQUAL"] = 1] = "LEQUAL";
    TextureCompareMode[TextureCompareMode["GEQUAL"] = 2] = "GEQUAL";
    TextureCompareMode[TextureCompareMode["LESS"] = 3] = "LESS";
    TextureCompareMode[TextureCompareMode["GREATER"] = 4] = "GREATER";
    TextureCompareMode[TextureCompareMode["EQUAL"] = 5] = "EQUAL";
    TextureCompareMode[TextureCompareMode["NOTEQUAL"] = 6] = "NOTEQUAL";
    TextureCompareMode[TextureCompareMode["ALWAYS"] = 7] = "ALWAYS";
    TextureCompareMode[TextureCompareMode["NEVER"] = 8] = "NEVER";
})(TextureCompareMode || (TextureCompareMode = {}));
